import { render, staticRenderFns } from "./TableAllergies.vue?vue&type=template&id=2923e95c"
import script from "./TableAllergies.vue?vue&type=script&lang=js"
export * from "./TableAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports